var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "112px",
    height: "99px",
    viewBox: "0 0 112 99",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-156.000000, -55.000000)",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-icon",
    transform: "translate(157.922242, 57.488335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7077856,79.0831339 C38.1814747,91.3578126 55.8794483,97.0625283 73.2422526,92.4101789 C98.3151595,85.6919138 113.194536,59.9200768 106.476271,34.84717 C99.7580062,9.77426313 73.9861692,-5.10511387 48.9132624,1.61315127 C27.3414417,7.39330319 13.315135,27.2774009 14.0972049,48.6857973",
    id: "Oval",
    stroke: "#3E87CB"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#F89B55",
    strokeLinejoin: "round",
    points: "0 31.2479528 14.2431171 51.7167615 33.8225413 34.459331"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.dcc51f3eb1fc4ed829d7c1090cbb46ce.svg";
export { ForwardRef as ReactComponent };